type Reducer<T, R> = (accum: R, cur: T) => R;

function countIfReducer<T>(predicate: (v: T) => boolean): Reducer<T, number> {
    return (accum: number, cur: T) => accum + +predicate(cur);
}

export function countIf<T>(values: readonly T[], predicate: (v: T) => boolean): number {
    return values.reduce(countIfReducer(predicate), 0);
}

/**
 * Counts occurrences of each key, in order of first appearance.
 */
export function countBy<T, K>(seq: Iterable<T>, keyFn: (item: T) => K): Map<K, number> {
    const counts = new Map<K, number>();
    for (const item of seq) {
        const key = keyFn(item);
        counts.set(key, (counts.get(key) ?? 0) + 1);
    }
    return counts;
}

export function sum(seq: Iterable<number>): number {
    let result = 0;
    for (const num of seq) {
        result += num;
    }
    return result;
}

export function sumBy<T>(seq: Iterable<T>, selector: (item: T) => number): number {
    let result = 0;
    for (const item of seq) {
        result += selector(item);
    }
    return result;
}

export function min(seq: Iterable<number>): number {
    return Math.min(...seq);
}

export function max(seq: Iterable<number>): number {
    return Math.max(...seq);
}
